export const resources = {
  'Queries': 'Consulta de Repuestos',
  'Kardex': 'Kardex',
  'Providers': 'Proveedores',
  'Origins': 'Orígenes',
  'PartAnalysis': 'Análisis de partes',
  'PartsSalesReport': 'Reporte de Ventas de Repuestos',
  'PartPrices': 'Precios de Repuestos',
  'IccMatrix': 'Matriz ICC',
  'IccMatrixParameters': 'Parámetros Matriz ICC',
  'InvoiceLoad': 'Ingreso de Facturas',
  'InvoiceQuery': 'Consulta de Facturas',
  'BackOrdersReport': 'Reporte de Back Orders',
  'BinningChecking': 'Binning Chequeo',
  'BinningStorage': 'Binning Guardado',
  'BinningClose': 'Binning Cierre',
  'LabelsReprinter': 'Reimprimir Etiquetas',
  'PickingDashboard': 'Picking Dashboard',
  'PickingWarehouseDenialCauses': 'Picking Warehouse Denied',
  'PickingShifts': 'Picking Cortes',
  'PickingZones': 'Picking Zonas',
  'PickingScanning': 'Picking Escaneo',
  'PickingManualsOrders': 'Picking Pedidos Manuales',
  'InternalOrders': 'Pedidos Internos',
  'ManualTransfers': 'Transferencias manuales',
  'Invoicing': 'Picking Facturación',
  'SalesKpi': 'KPI de Ventas',
  'SalesAndBudgetsLoad': 'Ingreso de Ventas y Presupuestos',
  'PartWatching': 'KPI Part Watching',
  'VehiclesKpi': 'Kpi Vehículos',
  'StoragePendingCarsList': 'Coches Pendientes',
  'SetSales': 'Kpi Venta Combos',
  'ReceivedAndDispatchedLinesKpi': 'Kpi Líneas Recepcionadas y Despachadas',
  'ParametersList': 'Parámetros Numéricos del Sistema',
  'UsersList': 'Usuarios del Sistema',
  'PartAudit': 'Auditoría de Partes',
  'WarehouseLocationsForm': 'Formulario Ubicación Bodega',
  'WarehouseLocations': 'Ubicaciones Bodega',
  'LocationAssignment': 'Formulario Cambio de Ubicación',
  'LocationsUsage': 'Reporte ubicaciones bodega',
  'MasterVehicleList': 'Listado Maestro de Vehículos',
  'MasterVehicleManage': 'Administración de Maestro de Vehículos',
  'ComboTasks': 'Relación tareas y combos',
  'LogisticTasks': 'Mantenimiento de Tareas de Logística',
  'LogisticModels': 'Mantenimiento de Modelos Flat Rate Logística',
  'LogisticAreas': 'Mantenimiento Áreas de Logística',
  'TechniciansGroups': 'Mantenimiento de Grupos Técnicos',
  'Technicians': 'Mantenimiento de Técnicos',
  'AccessoriesOrders': 'Órdenes de accesorios',
  'PDSOrders': 'Órdenes de PDS',
  'QualityControlInvoicing': 'Facturación Control de Calidad',
  'QualityAssuranceOrders': 'Órdenes de Control de Calidad',
  'FormsSearch': 'Buscar Formularios',
  'FormsSkrSearch': 'Buscar Formularios SKR',
  'FormsManage': 'Administración de Formularios',
  'FormsSkrManage': 'Administración de Formularios SKR',
  'PartNumberCode': 'Mantenimiento de PNC',
  'LiquidationsList': 'Liquidaciones de Importaciones',
  'PartsCatalog': 'Japan Part Master List',
  'VehiclesEfficiencyKpi': 'Kpi Eficiencia de Vehículos',
  'PriceFactorsMaintenance': 'Mantenimiento de factores de precio',
  'ObsolescenceParameters': 'Parámetros de obsolescencia',
  'ManageDatesBudget': 'Gestión de semanas',
  'SpecialParts': 'Repuestos especiales',
  'PartQuotation': 'Cotizador de repuestos',
  'PartsMaster': 'Maestro de Repuestos',
  'ClientManagement': 'Administración de Cliente',
  'AdvisorManagement': 'Administración de Asesor',
  'ExemptionPercentagesManagement':
  'Administración de porcentajes de exoneración',
  'VehiclesModels': 'Gestión de segmentos',
  'ManageColors': 'Gestión de colores',
  'ManageColorsFormAdd': 'Creación de colores',
  'VehicleSaleForecast': 'Proyección ventas',
  'VehicleSaleForecastExonerated': 'Proyección ventas exonerados',
  'VehiclesMaintenance': 'Segmentos katashiki',
  'VehiclesHistoryColor': 'Vehículos Historial de Colores',
  'DailyVehiclesSalesAndStockReport': 'Reporte de Ventas y Stock Diario de Vehículos',
  'DailyVehiclesSalesAndStockSummary': 'Resumen de Ventas y Stock Diario de Vehículos',
  'DailyVehiclesSalesAndStockWholesales': 'Resumen de Ventas y Stock Diario Wholesales',
  'ProviderSpecialOrders': 'Pedidos especiales a proveedores',
  'ProviderStockOrders': 'Pedidos de stock a proveedores',
  'ProviderManualOrders': 'Pedidos manuales a proveedores',
  'ProviderOrdersSequenceConfig': 'Configuración secuencias de pedidos a proveedores',
  'ProviderOrdersManagement': 'Gestión de pedidos a proveedores',
  'ProviderAmountReport': 'Reporte de montos pedidos aereos y VOR',
  'ProviderOrdersDetail': 'Detalle de pedidos a proveedores',
  'DealerLostSalesReport': 'Reporte de ventas perdidas',
  'ProviderOrdersAuthorization': 'Proveedores autorizacion de pedidos',
  'ProviderOrdersAmountLimits': 'Proveedores limite de pedidos',
  'ProvidersImportations': 'Importaciones en Tránsito de Proveedores',
  'DealerAgencies': 'Concesionarios listado de agencias',
  'DealerStockOrders': 'Concesionarios pedidos de stock',
  'DealerEmergingOrders': 'Concesionarios pedidos emergentes',
  'DealerSpecialOrders': 'Concesionarios pedidos especiales',
  'DealerOrdersTracking': 'Concesionarios seguimiento de pedidos',
  'DealerOrdersImmobilized': 'Concesionarios pedidos inmovilizados',
  'DealerOrdersAdministration': 'Concesionarios administracion de pedidos',
  'DealerOrdersGroupedManagement': 'Concesionarios pedidos totales',
  'DealerOrdersPossDownload': 'Concesionarios descarga archivo POSS',
  'VehiclesCertification': 'CPO',
  'ListVehiclesCertification': 'Listar CPO',
  'VehiclesCertificationSale': 'Registro de Autos Vendidos CPO',
  'WholeSalePlanned': 'WholeSale Planeado',
  'SmByicc': 'SmByicc',
  'SetsOrders': 'Pedidos Combos',
  'StockAdjustment': 'Ajuste de Stock de Inventario',
  'DescriptionMantainStockAdjustment': 'Mantenimiento de ajuste de stock descripción',
  'FileInvoices': 'Facturación Electrónica',
  'TdeCalendar': 'Calendario Tems',
  'MonthClose': 'Cierre de Mes',
  'MaintainSaleForecast': 'Mantenimiento de proyección de ventas de vehículos',
  'ServiceReportPart': 'Tasa Servicio Repuestos',
  'TdeCalendarDetail': 'Detalle Calendario Tems',
  'VehAudi': 'Auditoría Vehículos',
  'PartsReturns': 'Devolución de Repuestos',
  'BoReport': 'Reporte Bo',
  'WarrantyErrorRate': 'Tasa Error de Garantías',
  'WarrantyTasksCodes': 'Códigos Tareas de Garantías',
  'WarrantyErrorCodes': 'Códigos Error de Garantías',
  'WarrantyReport': 'Reporte de Garantías',
  'WarrantyInsert': 'Ingreso de Garantías',
  'ExcelWarrantyInsert': 'Ingreso de Garantías Excel',
  'WarrantyQuery': 'Consulta de Garantías',
  'WarrantyInvoicing': 'Consulta Facturación de Garantías',
  'WarrantyAdminForm': 'Ingreso de Garantías Admin',
  'ProcessedWarranty': 'Consulta de Garantías Procesadas',
  'TdeCalendarCPD': 'Calendario Repuestos',
  'TdeCalendarLOG': 'Calendario Logistica',
  'TdeCalendarVEH': 'Calendario Comercial',
  'SearchCombosVehicles': 'Búsqueda de combos',
  'ItemBudget': 'Presupuesto Repuestos',
  'InvoicesList': 'Listado de Facturas',
  'MaintainFormsServices': 'Mantenimiento de Formularios',
  'MaintainCampaign': 'Mantenimiento de Campanas',
  'CampaignAndChassisServices': 'Consulta de campaña y chasis',
  'WarrantyCampaignsReport': 'Reporte de Garantías en Campañas',
  'ListVehiclesWaitHappy': 'Listado de vehículos',
  'DealerWaitHappy': 'Ingreso del concesionario',
  'AgencyWaitHappy': 'Ingreso de la agencia',
  'TimeMarked': 'Marcados de Tiempos',
  'LubricantsInvoicing': 'Facturación de lubricantes',
  'PrioritizationIndicesReport': 'Reporte de Índices de Priorización',
  'LogisticIndicesReport': 'Reporte de Índices de Logística',
  'KanbanLogistics': 'Kanban Logística',
  'vehiclesAvailability': 'Disponibilidad de Vehículos',
  'vehicleHistory': 'Historial de Vehículos',
  'AccessoriesInvoicing': 'Facturación de Accesorios',
  'ReportCombos': 'Reporte combos',
  'CodeWithoutLabels': 'Códigos sin etiquetas',
  'AnticipatedInvoiceVehicleSelection': 'Facturación Anticipada Selección Vehículos',
  'AnticipatedInvoiceVehicleValidation': 'Facturación Anticipada Validación Vehículos',
  'DispatchOrdersApproval': 'Aprobación Órdenes de Despacho',
  'DispatchOrders': 'Órdenes de Despacho',
  'DevicesOrders': 'Órdenes de Dispositivos',
  'ManageOrdersCreate': 'Manejo de órdenes de importación de vehículos',
  'RequestsInstallationDevice': 'Solicitudes de instalación de dispositivo',
  'VehiclesInventory': 'Inventario de Vehículos',
  'FloatingInventory': 'Inventario Flotante de Vehículos',
  'CustomerTracking': 'Seguimiento de orden para cliente',
  'FloatingInventoryAudit': 'Auditoría de Inventario Flotante de Vehículos',
  'FloatingInventoryReport': 'Reporte de Inventario Flotante de Vehículos',
  'PartsImportsDashboard': 'Dashboard de Importaciones de Repuestos',
  'PartsImportsTrackingDashboard': 'Tracking de Importaciones de Repuestos',
  'MailGroups': 'Grupos de Correo',
  'BulletinService': 'Boletin de Servicio',
  'BulletinTMC': 'Boletin TMC',
  'BulletinQuery': 'Consulta de boletines',
  'AccessoriesRequest': 'Pedidos de accesorios facturación anticipada',
  'AccessoriesRequestSummary': 'Pedidos de accesorios facturación anticipada Resumen',
  'CombosManagement': 'Administración Combos',
  'TransportistManagement': 'Gestión de Transportistas',
  'AgenciesManagement': 'Gestión de Agencias',
  'VehiclesPriorizationDates': 'Producción de vehículos',
  'VehiclesPriorizationDailyQuota': 'Priorización Administrar cupo diario',
  'DevicesStock': 'Stock Bodega Dispositivos',
  'CommercialUsers': 'Mantenimiento y gestión de usuarios de Academia Toyota',
  'AccountList': 'Listado Estado de Cuenta',
  'PartsSalesJapan': 'Reporte Ventas Japón',
  'PartsLocationDashboard': 'Parts Location Dashboard',
  'WtsCatalogos': 'WTS Catalogos',
  'WtsEmpleados': 'WTS Empleados',
  'WtsCursos': 'WTS Mantenimiento Cursos',
  'WtsCalendario': 'WTS Calendario Agendamientos',
  'WtsMatricula': 'WTS Matriculacion',
  'WtsRegistroServicios': 'WTS Registro Servicios',
  'WtsEmpleadosGestor': 'WTS Empleados Gestor',
  'WtsRegistroTrabajoAgencias': 'WTS Registro Tranajo Agencias',
  'DealerOrdersEtaManagement': 'Gestión de ETAs de Repuestos',
};

export const scopes = {
  'Audit': 'Auditar',
  'See': 'Visualizar',
  'Create': 'Crear',
  'Edit': 'Editar',
  'Disabled': 'Deshabilitar',
  'Delete': 'Eliminar',
  'Approve': 'Aprobar',
  'KardexSee': 'Visualizar Kardex',
  'PartialSee': 'Visualizar parcialmente',
  'LimitedSee': 'Visualizar limitadamente',
  'ForOthers': 'Crear Para Otros',
  'Price': 'Visualizar Precios',
  'VehiclesCertification': 'TCC',
  'ListVehiclesCertification': 'Listar TCC',
  'ProductEdit': 'Editar Producto',
  'SalesEdit': 'Editar Ventas',
  'LogisticEdit': 'Editar Logística',
  'ImportationsEdit': 'Editar Importaciones',
  'ServiceEdit': 'Editar Servicio',
  'PartsLocationDashboard': 'Dashboard de Ubicaciones de Repuestos',
  'WtsMatricula': 'Matricular Participantes cursos WTS',
};
